import React, { useState, useEffect, useRef } from 'react';
import { Carousel, Button, message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './HomeBanner.module.scss';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { getBannerList, getBannerTypeList } from '@/api/banner';
import { getSuggestWebProductList, getOrderCount, getOrderPageList } from '@/api/order';
import { getProductCategoryAllList } from '@/api/products';
import bg2 from '@/assets/images/c642aea46612126d21e6c7243617286-01@2x.png';
import icon1 from '@/assets/images/homeLiveNow1.png';
import icon2 from '@/assets/images/homeLiveNow2.png';
import icon3 from '@/assets/images/homeLiveNow3.png';
import icon4 from '@/assets/images/homeLiveNow4.png';
import icon5 from '@/assets/images/组件 7@2x.png';
import icon6 from '@/assets/images/组 2359@2x.png';
import icon7 from '@/assets/images/组 2360@2x.png';
import icon8 from '@/assets/images/路径 2258@2x.png';
import icon9 from '@/assets/images/HomeMembershipIcon.png';
import icon10 from '@/assets/images/homeProductIcon.png';
import icon11 from '@/assets/images/homeServiceIcon.png';
import icon12 from '@/assets/images/cartIcon.png';
import { useTranslation } from 'react-i18next';



interface HomeBannerProps {
  // children: React.ReactNode;
  // getMessage?: (str: string) => void; // 可选的回调函数
}

//服务分类类型
interface IClassification {
  is_active: boolean;
  is_delete: boolean;
  order: any;
  parent_id: number;
  product_category_id: number;
  product_category_name: string;
  child?: IClassification[];
}



const HomeBanner: React.FC<HomeBannerProps> = ({ }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const userInfo = useAppSelector((state) => state.user.userInfo);

  // 订单统计数据
  const [orderCount, setOrderCount] = useState({
    order_wait_payment_count: 0,
    order_paid_count: 0,
    order_complete_count: 0,
    order_canceled_count: 0
    
  });

  // 最近订单列表
  const [recentOrders, setRecentOrders] = useState<any[]>([]);


  // 左侧列表
  const [list, setList] = useState<any[]>([
    // {
    //   title: 'Coat',
    //   price: '25.00',
    //   img: icon1
    // },
    // {
    //   title: 'Mouse',
    //   price: '25.00',
    //   img: icon2
    // },
    // {
    //   title: 'Sofa Chair',
    //   price: '25.00',
    //   img: icon3
    // },
    // {
    //   title: 'Smart Watch',
    //   price: '25.00',
    //   img: icon4
    // },
  ]);


  //轮播数据
  const [bannerList, setBannerList] = useState<any[]>([]);
  //轮播类型数据
  const [bannerTypeList, setBannerTypeList] = useState([]);
  

  useEffect(() => {
    setRightMenuList2([
    {
      title: t('home.YourCart'),
      img: icon5,
      to: '/yourtownloop/cart',
    },
    {
      title: t('home.YourFavorites'),
      img: icon6,
      to: '/yourtownloop/favorites',
    },
    {
      title: t('home.BrowsingHistory'),
      img: icon7,
      to: '/yourtownloop/browsingHistory',
    },
    {
      title: t('home.YourAddresses'),
      img: icon8,
      to: '/yourtownloop/addresses',
    },
  ]);
  setLiveNowList([
    { id: 'ln-1', img: icon1, title: t('home.HandmadeBaskets') },
    { id: 'ln-2', img: icon2, title: t('home.FreshDesserts') },
    { id: 'ln-3', img: icon3, title: t('home.BakeryBread') },
    { id: 'ln-4', img: icon4, title: t('home.AirFryer') },
  ]);
  }, [i18n.language]); // 将语言作为依赖项
  // 左侧列表
  const [rightMenuList2, setRightMenuList2] = useState([
    {
      title: t('home.YourCart'),
      img: icon5,
      to: '/yourtownloop/cart',
    },
    {
      title: t('home.YourFavorites'),
      img: icon6,
      to: '/yourtownloop/favorites',
    },
    {
      title: t('home.BrowsingHistory'),
      img: icon7,
      to: '/yourtownloop/browsingHistory',
    },
    {
      title: t('home.YourAddresses'),
      img: icon8,
      to: '/yourtownloop/addresses',
    },
  ]);

  // 左侧 flashPurchase 的"Live Now"数据
  const [liveNowList, setLiveNowList] = useState([
    { id: 'ln-1', img: icon1, title: t('common.HandmadeBaskets') },
    { id: 'ln-2', img: icon2, title: t('common.FreshDesserts') },
    { id: 'ln-3', img: icon3, title: t('common.BakeryBread') },
    { id: 'ln-4', img: icon4, title: t('common.AirFryer') },
  ]);

  // 服务分类相关状态
  const [serviceCategoriesWithSub, setServiceCategoriesWithSub] = useState<IClassification[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [activePrimary, setActivePrimary] = useState<IClassification | null>(null);
  const [panelPos, setPanelPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
  const [activeSecondary, setActiveSecondary] = useState<IClassification | null>(null);
  const serviceRef = useRef<HTMLDivElement | null>(null);


  const onChange = (currentSlide: number) => {
    // console.log(currentSlide);
  };

  const goLiveNow = () => {
    // message.info('Coming soon');
    navigate('/liveNow')
  }

  useEffect(() => {
    //console.log(location.pathname);
    getBannerTypeList({
      purpose: 1,
      path: '/'
    }).then((res) => {
      if (res.code == 200) {
        setBannerTypeList(res.data);
        const bannerType = res.data.find((item: any) => item.path == location.pathname);
        if (bannerType) {
          getBannerList({ path: location.pathname, purpose: 1 }).then((res2) => {
            if (res2.code == 200) {
              setBannerList(res2.data);
            }
          });
        }

      }
    });

    getSuggestWebProductList({ num: 4 }).then((res) => {
      if (res.code == 200) {
        setList(res.data);
      }
    })

    // 如果用户已登录，获取订单数据
    if (userInfo) {
      // 获取订单统计
      getOrderCount().then((res) => {
        //console.log(res,'res.data订单统计');
        if (res.code == 200) {
          // 根据新的接口数据结构处理订单统计
          const statusCount = res.data?.product_order_status_count || {};
          setOrderCount({
            order_wait_payment_count: statusCount['1'] || 0,  // 待支付 Unpaid
            order_paid_count: statusCount['3'] || 0,         // 已支付/待发货 Paid
            order_complete_count: statusCount['5'] || 0,     // 已完成 Completed
            order_canceled_count: statusCount['2'] || 0      // 已取消 Cancelled
          });
        }
      });

      // 获取最近订单列表
      getOrderPageList({page_num:1,page_size:1}).then((res) => {
        if (res && res.code == 200 && Array.isArray(res.data)) {
          //console.log(res.data,'res.data最近订单列表');
          setRecentOrders(res.data);
        } else {
          console.warn('Invalid recent orders data:', res);
          setRecentOrders([]);
        }
      }).catch((error) => {
        console.error('Failed to fetch recent orders:', error);
        setRecentOrders([]);
      });
    }

  }, [userInfo]);

  // 获取服务分类数据
  useEffect(() => {
    setLoading(true);
    // 获取分类列表 - product_category_type_id 1商品
    getProductCategoryAllList(1).then((res) => {
      //console.log(res, 'getProductCategoryAllList');
      if (res.code === 200) {
        const data = res.data || [];
        setServiceCategoriesWithSub(data);
      }
    }).catch((error) => {
      console.error('获取服务分类失败:', error);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  // 分类点击导航（用于二级、三级）
  const handleCategoryNavigate = (cat: IClassification) => {
    console.log(cat, 'cat');
    if (!cat) return;
    // 传递分类ID到SearchList页面
    navigate(`/searchList?product_category_id=${cat.product_category_id}`);
    // 关闭面板
    setActivePrimary(null);
  };

  // 当一级切换时，默认选中第一个二级
  useEffect(() => {
    if (activePrimary && activePrimary.child && activePrimary.child.length > 0) {
      setActiveSecondary(activePrimary.child[0]);
    } else {
      setActiveSecondary(null);
    }
  }, [activePrimary]);

  return (
  <div>
      <div className={styles.bannerBox}>
        {/* 上方左侧区域 */}
      <div className={styles.bannerBoxLeft}>
          <div
            ref={serviceRef}
            className={styles.serviceClassification}
            onMouseLeave={() => {
              setActivePrimary(null);
            }}
          >
            <h3>{t('home.ProductCategories')}</h3>
            <div className={styles.categoryContainer}>
              <ul className={styles.primaryList}>
                {serviceCategoriesWithSub.map((category) => (
                  <li
                    key={category.product_category_id}
                    className={styles.primaryItem}
                    onMouseEnter={(e) => {
                      setActivePrimary(category);
                      const box = serviceRef.current?.getBoundingClientRect();
                      const itemRect = (e.currentTarget as HTMLElement).getBoundingClientRect();
                      const top = box ? box.top : itemRect.top;
                      const left = itemRect.right + 10;
                      setPanelPos({ top, left });
                    }}
                    onClick={() => handleCategoryNavigate(category)}
                  >
                    {category.product_category_name}
                  </li>
                ))}
              </ul>

              {activePrimary && (
                <div
                  className={styles.megaPanel}
                  style={{ top: panelPos.top+50, left: panelPos.left }}
                >
                  {(activePrimary.child || []).map((sec) => (
                    <div key={sec.product_category_id} className={styles.megaColumn}>
                      <div
                        className={styles.megaTitle}
                        onClick={() => handleCategoryNavigate(sec)}
                      >
                        <span>{sec.product_category_name}</span>
                      </div>
                      {/* <div className={styles.megaLinks}>
                        {(sec.child || []).map((third, index) => (
                          <React.Fragment key={third.product_category_id}>
                            <span
                              className={styles.megaLink}
                              onClick={() => handleCategoryNavigate(third)}
                            >
                              {third.product_category_name}
                            </span>
                            {index < ((sec.child || []).length - 1) && <span>&nbsp;/&nbsp;</span>}
                          </React.Fragment>
                        ))}
                      </div> */}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
      </div>
      {/* 上方中间区域 */}
      <div className={styles.bannerBoxMiddle}>
        <Carousel afterChange={onChange} arrows autoplay>
          {
            bannerList.map((item, index) => (
              <div key={index} onClick={() => navigate(item.link_url)}>
                <img src={item.image_url} alt="" className={styles.bannerBoxMiddleImg} />
              </div>
            ))
          }


        </Carousel>
      </div>
{/* 上方右侧区域 */}
      <div className={styles.bannerBoxRight}>
        <div className={styles.bannerRightBox1}>
          <img src={bg2} alt="" className={styles.bannerBoxMiddleImg} />
          <div className={styles.bannerRightTextBox1}>
            <div className={styles.bannerRightText1}>{userInfo?.username || t('login.Nickname')}</div>
            {
              !userInfo ?
                <div className={styles.bannerRightText2}>{t('login.register')}</div>
                :
                <div className={styles.bannerRightText2}>{t('common.ManageAccounts')}</div>
            }

          </div>
        </div>

        {
          !userInfo ?
            <div className={styles.bannerRightBox2}>
              <div className={styles.bannerRightText3}>{t('home.logWonder')}</div>
              <div className={styles.bannerRightText4}>{t('home.betterSearch')}</div>
              <Button
                type="primary"
                className={styles.bannerRightBtn}
                onClick={() => navigate('/login')}
              >{t('home.logNow')}</Button>
            </div>
            :
            <div className={styles.orderStatusBox}>
              {/* 订单状态统计 */}
              {/* Unpaid、Paid/Unused、Completed、Cancelled、Refunded */}
              <div className={styles.orderStatusStats}>
                <div className={styles.orderStatusItem} onClick={() => navigate('/yourtownloop/orders?status=1')}>
                  <div className={styles.orderStatusCount}>{orderCount.order_wait_payment_count}</div>
                  <div className={styles.orderStatusLabel}>{t('home.PendingPayment')}</div>
                </div>
                <div className={styles.orderStatusItem} onClick={() => navigate('/yourtownloop/orders?status=2')}>
                  <div className={styles.orderStatusCount}>{orderCount.order_canceled_count}</div>
                  <div className={styles.orderStatusLabel}>{t('home.Cancelled')}</div>
                </div>
                <div className={styles.orderStatusItem} onClick={() => navigate('/yourtownloop/orders?status=3')}>
                  <div className={styles.orderStatusCount}>{orderCount.order_paid_count}</div>
                  <div className={styles.orderStatusLabel}>{t('home.Paid')}</div>
                </div>
                <div className={styles.orderStatusItem} onClick={() => navigate('/yourtownloop/orders?status=5')}>
                  <div className={styles.orderStatusCount}>{orderCount.order_complete_count}</div>
                  <div className={styles.orderStatusLabel}>{t('home.Completed')}</div>
                </div>
             
              </div>

              {
                recentOrders && Array.isArray(recentOrders) && recentOrders.length > 0 ? (
                  <div className={styles.recentOrdersBox}>
                    <div className={styles.recentOrdersTitle}>{t('home.RecentOrders')}</div>
                    {recentOrders
                      .filter(order => order && typeof order === 'object') // 过滤掉无效的订单数据
                      .map((order, index) => {
                        const orderId = order?.parent_order?.order_id || order?.product_order_id || '';
                        const firstItem = order?.order_item_list?.[0];
                        const product = firstItem?.product || {};
                        const productImage = product?.product_media_list?.[0]?.product_media_file_url || '';
                        const productTitle = product?.product_title || t('common.Product');
                        
                        return (
                          <div key={orderId || index} className={styles.recentOrderItem} onClick={() => {
                            try {
                              navigate('/yourtownloop/orders');
                            } catch (error) {
                              console.error('Navigation error:', error);
                            }
                          }}>
                            <div className={styles.recentOrderLeft}>
                              {productImage && (
                                <img 
                                  src={productImage} 
                                  alt={productTitle} 
                                  className={styles.recentOrderImg}
                                  onError={(e) => {
                                    // 图片加载失败时的兜底处理
                                    e.currentTarget.style.display = 'none';
                                  }}
                                />
                              )}
                              <div className={styles.recentOrderInfo}>
                                <div className={styles.recentOrderTitle}>
                                  {productTitle}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <div className={styles.recentOrderBox}>
                    <div className={styles.recentOrderTitle}>{t('home.RecentOrders')}</div>
                    <div className={styles.recentOrderItem}>
                        <div className={styles.recentOrderImg}>
                          <img src={icon12} alt="" />
                        </div>
                        <div className={styles.recentOrdername}>{t('home.NoDataAvailable')}</div>
                    </div>
                  </div>
                )
              }
            </div>
        }
        {/* {
            <div className={styles.recentOrderBox}>
              <div className={styles.recentOrderTitle}>Recent Orders</div>
              <div className={styles.recentOrderItem}>
                  <div className={styles.recentOrderImg}>
                    <img src={icon1} alt="" />
                  </div>
                  <div className={styles.recentOrderTitle}>Handmade Bamboo Basket: Woven with Bamboo Strips, Fine, Durable</div>
              </div>
            </div>
        } */}
        
        {/* 下方右侧区域 */}
        <div className={styles.bannerRightBox3}>
          {
            rightMenuList2.map((item, index) => (
              <div className={styles.bannerRightBox3Item} key={index} onClick={() => navigate(item.to || '/')}>
                <div className={styles.bannerRightBox3Img}>
                  <img src={item.img} alt="" />
                </div>
                <div className={styles.bannerRightText5}>
                  {item.title}
                </div>
              </div>
            ))
          }

        </div>

        {/* <div className={styles.bannerRightBox4} onClick={() => navigate('/login')}>
          Coupon information
        </div> */}

      </div>
    </div>
    {/* 下方左侧区域 */}
    <div className={styles.bannerBox + ' ' + styles.flashPurchase}>
      <div className={styles.leftFlashPurchase}>
        <div className={styles.liveHeader}>
          {t('common.LiveNow')}
          <span className={styles.liveSub}>({t('home.ExclusiveLiveDeals')})</span>
        </div>
        <div className={styles.liveGrid}>
          {liveNowList.map((it) => (
            <div key={it.id} className={styles.liveCard} onClick={goLiveNow}>
              <img src={it.img} alt="" className={styles.liveImg} />
              <span className={styles.liveBadge}>
                
              </span>
              <div className={styles.liveText} title={it.title}>{it.title}</div>
            </div>
          ))}
        </div>
      </div>
      {/* 下方中间区域 */}
      <div className={styles.centerflashPurchase}>
        <div className={styles.flashHeader}>
          <div className={styles.headerLeft}>{t('home.FlashSale')}<span className={styles.subTitle}>({t('home.LimitedTimeOnly')})</span></div>
          <div className={styles.headerRight} onClick={() => navigate('/searchList?flashSale=1')}>{t('home.SaveMoreBeforeTimeRunsOut')}</div>
        </div>
        <div className={styles.productGrid}>
          {
            list.map((item, index) => (
              <div
                className={styles.productCard}
                key={index}
                onClick={() => navigate(`/productDetail/${item?.product_id}`)}
              >
                <img src={item?.product_media_list[0]?.product_media_file_url} alt="" className={styles.productImg} />
                <div className={styles.productInfo}>
                  <div className={styles.productName} title={item?.product_title}>{item?.product_title}</div>
                  <div className={styles.productPrice}>${item?.product_sku_values[0]?.product_price}</div>
                </div>
              </div>
            ))
          }
        </div>
      </div>

      {/* 下方右侧区域 */}
      <div className={styles.flashRightZones}>
        <div className={styles.zoneItem} onClick={() => navigate('/searchList?activeTabIndex=0')}>
          <div className={styles.zoneIcon}><img src={icon9} alt="" /></div>
          <div className={styles.zoneTexts}>
            <div className={styles.zoneTitle}>{t('home.ProductZone')}</div>
            <div className={styles.zoneSub}>{t('home.QualityProductsEasyShopping')}</div>
          </div>
        </div>
        <div className={styles.zoneItem} onClick={() => navigate('/searchList?activeTabIndex=1')}>
          <div className={styles.zoneIcon}><img src={icon11} alt="" /></div>
          <div className={styles.zoneTexts}>
            <div className={styles.zoneTitle}>{t('home.ServiceZone')}</div>
            <div className={styles.zoneSub}>{t('home.ProfessionalHelpAnytime')}</div>
          </div>
        </div>
        <div className={styles.zoneItem} onClick={() => navigate('/membershipService')}>
          <div className={styles.zoneIcon}><img src={icon10} alt="" /></div>
          <div className={styles.zoneTexts}>
            <div className={styles.zoneTitle}>{t('common.Membership')}</div>
            <div className={styles.zoneSub}>{t('home.JoinEnjoyMore')}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default HomeBanner; 